import React, { useMemo, useCallback } from 'react'
import MaterialReactTable from 'material-react-table';
import {
    Typography,
    Box,
    Button,
    IconButton,
    Tooltip,
} from '@mui/material';
//Import Material React Table Translations
import { MRT_Localization_ES } from 'material-react-table/locales/es';
import { grey } from '@mui/material/colors';
import { darken, useTheme, createTheme, ThemeProvider } from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import PlaylistAddIcon from '@mui/icons-material/PlaylistAdd';
import { Delete, Edit } from '@mui/icons-material';
import { useNavigate } from 'react-router-dom';

const TablaInfo = ({ columnas, lineas, handleOpen, acciones = false, handleUpdateEvento }) => {
    const navigate = useNavigate();
    const [data, setData] = React.useState(lineas)
    const columns = useMemo(() => columnas, [data])
    const [pagination, setPagination] = React.useState({
        pageIndex: 0,
        pageSize: 5
    });

    React.useEffect(() => {
        if (lineas.length > 0) {
            setData(lineas)
        }
    }, [lineas])

    //abrir modal
    const openModal = (row) => {
        var id = row.original._new_eventodecapacitacion_id
        navigate(`/informacion-eventos/${id}`)
    }

    const aplicarEvento = (row) => {
        var id = row.original.id
        handleUpdateEvento(id)
    }

    return (
        <>
            <MaterialReactTable
                muiTablePaginationProps={{
                    rowsPerPageOptions: [5, 10],
                }}
                columns={columns}
                data={data}
                muiTablePaperProps={{
                    sx: (theme) => ({
                        borderRadius: '0.55rem',
                        border: darken(theme.palette.background.default, 0.1),
                        bgcolor: darken(theme.palette.primary.dark, 0.1),
                        maxWidth: '1042px',
                        m: 'auto',
                    }),
                }}
                onPaginationChange={setPagination}
                state={{ pagination }}
                enableColumnFilterModes={true}
                enableColumnOrdering={true}
                enableColumnFilters={true}
                enableSorting={true}
                columnResizeMode="onChange"
                enablePinning
                enableRowActions={acciones}
                enableStickyHeader
                initialState={{ showColumnFilters: false, columnVisibility: { id: false }, density: 'compact', }}
                positionToolbarAlertBanner="bottom"
                localization={MRT_Localization_ES}
                defaultColumn={{
                    maxSize: 400,
                    minSize: 40,
                }}
                renderRowActions={({
                    row
                }) => <div style={{
                    display: 'flex',
                    flexWrap: 'nowrap',
                    gap: '0.7rem',
                    margin: '5px'
                }}>
                        <Button variant="contained" color="secondary" onClick={() => openModal(row)}>
                            Conocer más
                        </Button>
                        <Button variant="contained" color="secondary" onClick={() => aplicarEvento(row)}>
                            Aplicar
                        </Button>
                    </div>}
            />
        </>
    )
}

export default TablaInfo